import Button from 'components/Button';
import Input from 'components/Input';
import { Modal } from 'components/ModalV2';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'components/Tabs';
import Shipment from 'interfaces/PmParcel';
import LoadingDots from 'components/LoadingDots';
import {
  Content,
  ErrorMessage,
  InputContainer,
  SubmitButtonContainer,
} from './ConsumerValidationModal.style';
import useConsumerValidationModal from './hooks/useConsumerValidationModal';

interface ConsumerValidationModalProps {
  isOpen: boolean;
  shipment: Shipment;
  onClose: () => void;
  onValidateSucceed: (shipment: Shipment) => void;
}

const ConsumerValidationModal = ({
  isOpen,
  shipment,
  onClose,
  onValidateSucceed,
}: ConsumerValidationModalProps): JSX.Element => {
  const {
    buttonText,
    modalTitle,
    tabs,
    shouldShowTabs,
    onChangeTab,
    onValidating,
    formFields,
    errors,
    onChangeForm,
    onSubmitForm,
  } = useConsumerValidationModal(shipment, onValidateSucceed);

  const formContent = (
    <Content>
      {formFields.map(({ name, value, label, error }, index) => (
        <InputContainer>
          <Input
            key={`input-${name}`}
            name={name}
            value={value}
            label={label}
            error={error}
            onChange={onChangeForm}
            required
          />
        </InputContainer>
      ))}
      {errors.general && (
        <ErrorMessage size="lg" isError>
          {errors.general}
        </ErrorMessage>
      )}
      <SubmitButtonContainer>
        <Button block type="submit">
          {buttonText} {onValidating && <LoadingDots />}
        </Button>
      </SubmitButtonContainer>
    </Content>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      aria={{
        labelledby: 'consumer-validation-modal-heading',
      }}
    >
      <Modal.Header id="consumer-validation-modal-heading">
        {modalTitle}
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmitForm}>
          <Tabs onSelectionChange={onChangeTab}>
            {shouldShowTabs && (
              <TabList>
                {tabs.map(({ key, label }) => (
                  <Tab key={key} id={key}>
                    {label}
                  </Tab>
                ))}
              </TabList>
            )}
            {shouldShowTabs ? (
              <TabPanels>
                {tabs.map(({ key }) => (
                  <TabPanel key={key}>{formContent}</TabPanel>
                ))}
              </TabPanels>
            ) : (
              formContent
            )}
          </Tabs>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export { ConsumerValidationModal };
